export class JurisdictionListItem {
    id: string;
    jurisdiction: string;
    isActive: boolean;
}
